/**
 * A page built for dusk renders this to tell the chat its light (PR-4a.2, 2026-09-25): <html
 * data-design-light="dusk"> while the page is on screen at dusk, nothing at noon, nothing once the page has gone
 * (./previewTheme.ts publishPageLight). The chat's skin reads it; the chat itself decides whether it can be drawn at
 * dusk for this viewer (../design/chatHooks.ts publishChatDusk).
 *
 * A layout effect, so the attribute is on <html> before the frame the page first paints in: the chat never shows one
 * frame at noon over a page already at dusk.
 *
 * ON THE FIRST DOWNLOAD (the home page's door renders it while its chunk arrives), so it imports nothing but React
 * and the publisher.
 */
import React from 'react';
import { publishPageLight, type PreviewTheme } from './previewTheme';

export const PageLight: React.FC<{ theme: PreviewTheme }> = ({ theme }) => {
  React.useLayoutEffect(() => {
    publishPageLight(theme);
    return () => publishPageLight(null);
  }, [theme]);
  return null;
};

export default PageLight;
